import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FaWhatsapp, FaLinkedinIn, FaInstagram,} from "react-icons/fa";
import { MdMailOutline } from "react-icons/md";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ["Digital Marketing Learner.", "Aspiring Digital Marketer."],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">

        <div className="text-lg font-normal uppercase">
          <span>WELCOME TO MY </span>
          <h1 className="inline text-lg font-normal uppercase">DIGITAL MARKETING PORTFOLIO</h1>
        </div>
        <h2 className="text-6xl font-bold text-white">
          Hi, <br></br>I'm <span className="text-designColor capitalize">Mukesh Kannan</span>
        </h2>
        <h2 className="text-4xl font-bold text-white">
          <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
        I am a digital marketing fresher with hands-on experience in SEO, Google Ads, social media marketing, and analytics. 
        I help improve online visibility, generate leads, and track performance using data-driven strategies.<br></br> 
        I enjoy learning new tools and applying practical techniques to grow businesses online.
        </p>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            Find me in
          </h2>
          <div className="flex gap-4">
            <a href="mailto:kannanmukesh856@gmail.com" target="blank">
              <span className="bannerIcon">
                <MdMailOutline />
              </span>
            </a>
            <a href="https://wa.me/919025595418" target="blank">
              <span className="bannerIcon">
                <FaWhatsapp />
              </span>
            </a>
            <a href="https://www.instagram.com/mukesh__2k3/" target="blank">
              <span className="bannerIcon">
                <FaInstagram />
              </span>
            </a>
            <a href="https://www.linkedin.com/in/mukesh-kannan-k/" target="blank">
              <span className="bannerIcon">
                <FaLinkedinIn />
              </span>
            </a>
            
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default LeftBanner;
